<mat-card class="main-card">

  <mat-toolbar color="default" class="toolbar">
    <h2 class="form-title">{{ 'oportunitats.dialeg.titol' | translate }}</h2>
    <span class="spacer"></span>
    <mat-form-field class="toolbar-id" appearance="outline" floatLabel="never">
      <input matInput name="id" [(ngModel)]="editOportunitatsData.id" readonly />
      <mat-icon matSuffix>lock</mat-icon>
    </mat-form-field>
    <div class="actions">
      <button *ngIf="rol === 2 || rol === 4" mat-icon-button (click)="desar()"
              [matTooltip]="'oportunitats.dialeg.desar' | translate">
        <mat-icon color="primary">save</mat-icon>
      </button>
      <button mat-icon-button (click)="close()"
              [matTooltip]="'oportunitats.dialeg.tancar' | translate">
        <mat-icon color="primary">close</mat-icon>
      </button>
    </div>
  </mat-toolbar>

  <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress"></mat-progress-bar>

  <mat-card-content class="content-scroll">
    <form #loginForm="ngForm" *ngIf="editOportunitatsData">
      <div class="form-grid">
  <!-- TÍTOL -->
    <mat-form-field class="col-6">
      <mat-label>{{ 'oportunitats.dialeg.cmptitol' | translate }}</mat-label>
      <input matInput name="titol" [(ngModel)]="editOportunitatsData.titol" />
    </mat-form-field>

  <!-- TIPUS -->
    <mat-form-field class="col-2" *ngIf="possibleTipus?.length">
      <mat-label>{{ 'oportunitats.dialeg.cmptipus' | translate }}</mat-label>
      <mat-select name="tipus" [(ngModel)]="editOportunitatsData.tipus">
        <mat-option *ngFor="let tipus of possibleTipus" [value]="tipus.text">
          {{ tipus.text }}
        </mat-option>
      </mat-select>
    </mat-form-field>

  <!-- TIPUS EXPRESSIÓ -->
    <mat-form-field
      *ngIf="editOportunitatsData.tipus === 'Expressió d\'interès' && possibleTipusExpressio?.length"
      class="col-2">
      <mat-label>{{ 'oportunitats.dialeg.cmptipus' | translate }}</mat-label>
      <mat-select name="tipusexpressio" [(ngModel)]="editOportunitatsData.tipus_expressio">
        <mat-option *ngFor="let tipus of possibleTipusExpressio"
                    [value]="tipus.text">
          {{ tipus.text }}
        </mat-option>
      </mat-select>
    </mat-form-field>

  <!-- ESTAT -->
    <mat-form-field class="col-2">
      <mat-label>{{ 'oportunitats.dialeg.cmpestat' | translate }}</mat-label>
      <mat-select name="estat"
                  [(ngModel)]="editOportunitatsData.estat">
        <mat-option value="Acceptada">{{ 'oportunitats.dialeg.estats.Acceptada' | translate }}</mat-option>
        <mat-option value="Descartada">{{ 'oportunitats.dialeg.estats.Descartada' | translate }}</mat-option>
        <mat-option value="Pendent de valorar">{{ 'oportunitats.dialeg.estats.Pendent de valorar' | translate }}</mat-option>
        <mat-option value="Possible">{{ 'oportunitats.dialeg.estats.Possible' | translate }}</mat-option>
      </mat-select>
    </mat-form-field>

  <!-- ÀMBIT -->
    <mat-form-field class="col-2" *ngIf="possibleAmbits?.length">
      <mat-label>{{ 'oportunitats.dialeg.cmpambit' | translate }}</mat-label>
      <mat-select name="ambit" [(ngModel)]="editOportunitatsData.ambit">
        <mat-option *ngFor="let ambit of possibleAmbits"
                    [value]="ambit.codi">
          {{ ambit.text }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- PRESSUPOST -->
    <mat-form-field class="col-2">
      <mat-label>{{ 'oportunitats.dialeg.cmppressupost' | translate }}</mat-label>
      <input matInput type="number" step="0.01"
             name="pressupost"
             [(ngModel)]="editOportunitatsData.pressupost" />
    </mat-form-field>

    <!-- DATES -->
    <mat-form-field class="col-2">
      <mat-label>{{ 'oportunitats.dialeg.cmpdata_limit_presentacio' | translate }}</mat-label>
      <input matInput type="date"
             name="data_limit_presentacio"
             [(ngModel)]="editOportunitatsData.data_limit_presentacio" />
    </mat-form-field>

    <mat-form-field class="col-2">
      <mat-label>{{ 'oportunitats.dialeg.cmpdata_publicacio' | translate }}</mat-label>
      <input matInput type="date"
             name="data_publicacio"
             [(ngModel)]="editOportunitatsData.data_publicacio" />
    </mat-form-field>

  <!-- PARTICIPACIÓ -->
    <mat-form-field class="col-2">
      <mat-label>{{ 'oportunitats.dialeg.cmpparticipacio' | translate }}</mat-label>
      <mat-select name="participacio" 
                  [(ngModel)]="editOportunitatsData.participacio">
        <mat-option value="Líders sense socis">Líders sense socis</mat-option>
        <mat-option value="Líders amb socis">Líders amb socis</mat-option>
        <mat-option value="Socis">Socis</mat-option>
        <mat-option value="Subcontractats">Subcontractats</mat-option>
      </mat-select>
    </mat-form-field>

  <!-- SOCIS POSSIBLES -->
    <mat-form-field class="col-4">
      <mat-label>Socis possibles</mat-label>
      <input matInput name="socis_possibles"
             [(ngModel)]="editOportunitatsData.socis_possibles" />
    </mat-form-field>

  <!-- COORDINADORS -->
    <mat-form-field class="col-4" *ngIf="possibleTecnics?.length">
      <mat-label>{{ 'oportunitats.dialeg.cmpcoordinador' | translate }}</mat-label>
      <mat-select multiple name="coordinadors"
                  [(ngModel)]="coordinadors">
        <mat-option *ngFor="let tecnic of possibleTecnics"
                    [value]="tecnic.text">
          {{ tecnic.text }}
        </mat-option>
      </mat-select>
    </mat-form-field>

  <!-- TÈCNICS SUPORT -->
    <mat-form-field class="col-4" *ngIf="possibleTecnics?.length">
      <mat-label>{{ 'oportunitats.dialeg.cmptecnic_suport' | translate }}</mat-label>
      <mat-select multiple name="tecnics_suport"
                  [(ngModel)]="tecnics_suport">
        <mat-option *ngFor="let tecnic of possibleTecnics"
                    [value]="tecnic.text">
          {{ tecnic.text }}
        </mat-option>
      </mat-select>
    </mat-form-field>

  <!-- URL -->
    <mat-form-field class="col-6">
      <mat-label>{{ 'oportunitats.dialeg.cmpurl' | translate }}</mat-label>
      <input matInput name="url"
             [(ngModel)]="editOportunitatsData.url" />
      <a *ngIf="editOportunitatsData.url"
         matSuffix
         [href]="editOportunitatsData.url"
         target="_blank">
        <mat-icon color="primary" style="mrgin-left:20px">cloud_circle</mat-icon>
      </a>
    </mat-form-field>

  <!-- PRIORITAT -->
    <div class="col-2 slider-container">
      <label>Prioritat {{ editOportunitatsData.prioritat }}</label>
      <mat-slider min="1" max="10" step="1"
                  [(ngModel)]="editOportunitatsData.prioritat"
                  name="prioritat"
                  thumbLabel
                  color="primary">
      </mat-slider>
    </div>

  <!-- NOTES -->
    <div class="col-3">
      <mat-form-field appearance="fill" class="flex-1">
        <mat-label>Data</mat-label>
        <input matInput name="dia" type="date" [(ngModel)]="dia">
      </mat-form-field>
      <button color="primary" mat-icon-button matTooltip="Afegir data a la nota" aria-label="Afegir data" matTooltipClass="tooltip-style" (click)="afegir(null)" style="float: right;clear: none;width:2%">
          <mat-icon style="font-size:24px;font-weight:bold">note_add</mat-icon>
      </button>
    </div>
    <div class="col-12">
       <quill-editor #quillEditor [styles]="{height: '200px', backgroundColor: '#EEEEEE'}" [(ngModel)]="editOportunitatsData.nota" name="nota" placeholder="Notes de les oportunitats" (onSelectionChanged)="setPos($event)"></quill-editor> 
       <button color="primary" mat-icon-button matTooltip="Afegir data" aria-label="Afegir data" matTooltipClass="tooltip-style" (click)="afegirE()" style="float: left;clear: none;width:2%">
       <mat-icon style="font-size:24px;font-weight:bold">note_add</mat-icon>
       </button>
    </div>

  <!-- SOLVÈNCIA -->
    <mat-form-field class="col-2">
      <mat-label>Solvència</mat-label>
      <mat-select name="solvencia"
                  [(ngModel)]="editOportunitatsData.solvencia">
        <mat-option value=""></mat-option>
        <mat-option value="Si">Si</mat-option>
        <mat-option value="No">No</mat-option>
      </mat-select>
    </mat-form-field>

  <!-- MEMÒRIA -->
    <mat-form-field class="col-2">
      <mat-label>Memòria</mat-label>
      <mat-select name="memoria_tecnica"
                  [(ngModel)]="editOportunitatsData.memoria_tecnica">
        <mat-option value=""></mat-option>
        <mat-option value="Si">Si</mat-option>
        <mat-option value="No">No</mat-option>
      </mat-select>
    </mat-form-field>

  <!-- PERFILS -->
    <mat-form-field class="col-2">
      <mat-label>Perfils</mat-label>
      <mat-select name="perfils_tecnics"
                  [(ngModel)]="editOportunitatsData.perfils_tecnics">
        <mat-option value=""></mat-option>
        <mat-option value="Totalment">Totalment</mat-option>
        <mat-option value="Parcialment">Parcialment</mat-option>
      </mat-select>
    </mat-form-field>

  <!-- AVALUACIÓ -->
    <mat-form-field class="col-2">
      <mat-label>Avaluació</mat-label>
      <mat-select name="avaluacio"
                  [(ngModel)]="editOportunitatsData.avaluacio">
        <mat-option value="Si">Si</mat-option>
        <mat-option value="No">No</mat-option>
      </mat-select>
    </mat-form-field>

  <!-- PUNTUACIÓ -->
    <div class="col-2 slider-container">
      <label>Puntuació: {{ editOportunitatsData.puntuacio_possible }}%</label>
      <mat-slider min="0" max="100" step="10"
                  [(ngModel)]="editOportunitatsData.puntuacio_possible"
                  name="puntuacio_possible"
                  thumbLabel
                  color="primary">
      </mat-slider>
    </div>

  <!-- OBSERVACIONS -->
    <mat-form-field class="col-12">
      <mat-label>{{ 'oportunitats.dialeg.cmpobservacions' | translate }}</mat-label>
      <textarea matInput rows="6"
                name="observacions"
                [(ngModel)]="editOportunitatsData.observacions">
      </textarea>
    </mat-form-field>

<!-- FOOTER FIX -->
<!--
    <div class="conversion-footer" *ngIf="editOportunitatsData.id !== 'NEW' && (rol === 2 || rol === 4)">
      <mat-form-field class="col-4">
        <mat-label>{{ 'oportunitats.dialeg.codi' | translate }}</mat-label>
        <input matInput name="codi" [(ngModel)]="editOportunitatsData.codi" />
      </mat-form-field>
      <mat-form-field class="col-6">
        <mat-label>{{ 'oportunitats.dialeg.opcions' | translate }}</mat-label>
        <mat-select [(ngModel)]="opcio" name="opcio">
          <mat-option value="1">{{ 'oportunitats.dialeg.preproposta' | translate }}</mat-option>
          <mat-option value="2">{{ 'oportunitats.dialeg.proposta' | translate }}</mat-option>
        </mat-select>
      </mat-form-field>
      <button mat-fab color="primary" (click)="crear()" [matTooltip]="'oportunitats.dialeg.convertir' | translate">
        <mat-icon>note_add</mat-icon>
      </button>
    </div>
  -->
 </div>
    </form>
  </mat-card-content>

</mat-card>
